module.exports = __webpack_public_path__ + "img/windscreen-fitter.a4f38fa4.png";